module.exports = __webpack_public_path__ + "static/media/soporteTecnico.e6baa61a.svg";